export default m => m / 10000
